import axios from 'axios';
import { req } from './axiosFun';


export const doWithdrawList = (params) => { return req("post", "/api/saas/xht/money/doWithdraw", params) };
export const finishWithdraw = (params) => { return req("post", "/api/saas/xht/money/finishWithdraw", params) };

//------台球订单
export const userCardList = (params) => { return req("post", "/api/saas/xht/money/userCard", params) };
export const editUserCard = (params) => { return req("post", "/api/saas/xht/money/editUserCard", params) };


// WEBPACK FOOTER //
// ./src/api/money.js